import { type Enum } from '../../utils/enums'

export const BillTypes = {
  ORDER: 0,
  EXPENSE: 1,
  CREDITCARD: 2,
} as const

export type BillType = Enum<typeof BillTypes>
